// Typelizer digest 3fca9e127b41c915b26509c8868a0cb3
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/activities/:activity_id/dismissal */
  create: (
    params: { activityId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/activities/:activity_id/dismissal', params, options),
    method: 'post',
  }),
}
